import React, { useState, useEffect, useRef  } from 'react';
import { useBranch } from '../../../layouts/BranchContext'; 
import {
  Button,
  Container,
  Box,
  Modal,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  InputAdornment,
  IconButton,
  Tooltip,
  Chip,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import FormHelperText from '@mui/material/FormHelperText';
import CloseIcon from '@mui/icons-material/Close';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { jsPDF } from 'jspdf';
import { usePdfSettings } from '../../../layouts/PdfSettingsContext.js';
import { ListSubheader } from '@mui/material';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

// Custom scrollbar styled component for modal
const CustomTableScrollbar = styled('div')(({ theme }) => ({
  overflowY: 'auto',
  backgroundColor: theme.palette.background.paper,
  '&::-webkit-scrollbar': {
    width: '6px',
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)',
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
  },
  scrollbarWidth: 'thin',
  scrollbarColor: `${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)'} transparent`,
}));

const AddRegistration = () => {
  const { selectedBranchId, branchList: branches } = useBranch();
  // Logged-in user / branch-admin context
  const [sessionUser] = useState(() => {
    try {
      return JSON.parse(sessionStorage.getItem("user") || "{}");
    } catch (e) {
      return {};
    }
  });
  const theme = useTheme();
  const navigate = useNavigate();
  const { pdfThemeColor, pdfTextColor } = usePdfSettings();
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  // State for location data
  const [allStates, setAllStates] = useState([]); // Store all states
  const [allCities, setAllCities] = useState([]); // Store all cities
  const [filteredStates, setFilteredStates] = useState([]); // Filtered states based on country
  const [filteredCities, setFilteredCities] = useState([]); // Filtered cities based on state
  const [mobileCountryCode, setMobileCountryCode] = useState('+91');

  const [formData, setFormData] = useState({
    sendSMS: false,
    registrationDate: new Date().toISOString().split('T')[0],
    candidateName: '',
    gender: '',
    mobileNo: '',
    email: '',
    dateOfBirth: '',
    country: '',
    state: '',
    city: '',
    address: '',
    nationality: '',
    registrationFee: '',
    courses: [],
  });

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [courses, setCourses] = useState([]);
  const [nationalities, setNationalities] = useState([]);
  const [enquiries, setEnquiries] = useState([]);
  const [enquiryModalOpen, setEnquiryModalOpen] = useState(false);
  const [selectedEnquiry, setSelectedEnquiry] = useState(null);
  const [enquirySearchTerm, setEnquirySearchTerm] = useState('');
const [loading, setLoading] = useState(true);
const [organizationId] = useState(() => {
  return sessionUser.organization_id || "";
});
  const [error, setError] = useState(null);
  const [formErrors, setFormErrors] = useState({});
  const [submitError, setSubmitError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';
  const token = localStorage.getItem('accessToken');
  const [courseModalOpen, setCourseModalOpen] = useState(false);
  const [tempCourses, setTempCourses] = useState([]);

  // Static data for dropdowns
  const staticGenderData = [
    { id: 1, name: 'Male' },
    { id: 2, name: 'Female' },
    { id: 3, name: 'Other' },
  ];

  useEffect(() => {
    const fetchMasterData = async () => {
      if (!token) {
        setError("No authentication token found");
        setLoading(false);
        return;
      }

      setLoading(true);
setError(null);
setCourses([]);
setEnquiries([]);

      try {
        const headers = {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        };

        // Countries
        const countriesRes = await fetch(`${API_BASE_URL}/api/master/countries/`, { headers });
        if (!countriesRes.ok) throw new Error(`Countries: ${countriesRes.status}`);
        const countriesData = await countriesRes.json();
        setCountries(Array.isArray(countriesData) ? countriesData : countriesData.data || []);

const courseParams = new URLSearchParams();
if (organizationId) courseParams.append('organisation', organizationId);
if (selectedBranchId) courseParams.append('branch', selectedBranchId);
const coursesRes = await fetch(`${API_BASE_URL}/api/course/courses/?${courseParams.toString()}`, { headers });
if (!coursesRes.ok) throw new Error(`Courses: ${coursesRes.status}`);
const coursesData = await coursesRes.json();
setCourses(
  coursesData.results || (Array.isArray(coursesData) ? coursesData : coursesData.data || [])
);

        // Nationalities
        const natRes = await fetch(`${API_BASE_URL}/api/master/nationalities/`, { headers });
        if (!natRes.ok) throw new Error(`Nationalities: ${natRes.status}`);
        const natData = await natRes.json();
        setNationalities(Array.isArray(natData) ? natData : natData.data || []);

// Enquiries - filtered by branch and organization
const enquiryParams = new URLSearchParams();
if (organizationId) enquiryParams.append('organisation', organizationId);
if (selectedBranchId) enquiryParams.append('branch', selectedBranchId);
const enquiryRes = await fetch(`${API_BASE_URL}/api/student_details/enquiries/?${enquiryParams.toString()}`, { headers });
if (!enquiryRes.ok) {
  console.warn(`Enquiries fetch failed: ${enquiryRes.status}`);
} else {
  const enquiryData = await enquiryRes.json();
  setEnquiries(
    enquiryData.results || (Array.isArray(enquiryData) ? enquiryData : enquiryData.data || [])
  );
}

        setLoading(false);
      } catch (err) {
        console.error("Master data fetch error:", err);
        setError(err.message || "Failed to load dropdown data");
        setLoading(false);
      }
    };

fetchMasterData();
  }, [selectedBranchId]);

  // Fetch all states
  useEffect(() => {
    const fetchAllStates = async () => {
      if (!token) return;

      try {
        const headers = { 'Authorization': `Bearer ${token}` };
        const res = await fetch(`${API_BASE_URL}/api/master/states/`, { headers });

        if (!res.ok) throw new Error("States fetch failed");
        const data = await res.json();
        const mappedStates = data.map(state => ({
          stateId: state.id,
          stateName: state.name || state.state_name || state,
          countryId: state.country || state.country_id
        }));
        setAllStates(mappedStates);
        setStates(mappedStates);
      } catch (err) {
        console.error("States fetch error:", err);
        setAllStates([]);
        setStates([]);
      }
    };

    fetchAllStates();
  }, [token]);

  // Fetch all cities
  useEffect(() => {
    const fetchAllCities = async () => {
      if (!token) return;

      try {
        const headers = { 'Authorization': `Bearer ${token}` };
        const res = await fetch(`${API_BASE_URL}/api/master/cities/`, { headers });

        if (!res.ok) throw new Error("Cities fetch failed");
        const data = await res.json();
        const mappedCities = data.map(city => ({
          cityId: city.id,
          cityName: city.name || city.city_name || city,
          stateId: city.state || city.state_id
        }));
        setAllCities(mappedCities);
        setCities(mappedCities);
      } catch (err) {
        console.error("Cities fetch error:", err);
        setAllCities([]);
        setCities([]);
      }
    };

    fetchAllCities();
  }, [token]);

  // Filter states when country changes
  useEffect(() => {
    if (!formData.country || !allStates.length) {
      setFilteredStates([]);
      setFormData(prev => ({ ...prev, state: '', city: '' }));
      return;
    }

    const selectedCountry = countries.find(c =>
      (c.name || c.country_name || c) === formData.country
    );

    if (selectedCountry) {
      const statesForCountry = allStates.filter(
        state => state.countryId === selectedCountry.id
      );
      setFilteredStates(statesForCountry);
    } else {
      setFilteredStates([]);
    }

    setFormData(prev => ({ ...prev, state: '', city: '' }));
    setFilteredCities([]);
  }, [formData.country, allStates, countries]);

  // Filter cities when state changes
  useEffect(() => {
    if (!formData.state || !allCities.length) {
      setFilteredCities([]);
      setFormData(prev => ({ ...prev, city: '' }));
      return;
    }

    const selectedState = allStates.find(s =>
      (s.stateName) === formData.state
    );

    if (selectedState) {
      const citiesForState = allCities.filter(
        city => city.stateId === selectedState.stateId
      );
      setFilteredCities(citiesForState);
    } else {
      setFilteredCities([]);
    }

    setFormData(prev => ({ ...prev, city: '' }));
  }, [formData.state, allCities, allStates]);

  useEffect(() => {
  setTempCourses([...formData.courses]);
}, [formData.courses]);

const handleChange = (e) => {
  const { name, value, type, checked } = e.target;

  if (type === 'checkbox') {
    setFormData(prev => ({ ...prev, [name]: checked }));
  } else if (name === 'mobileNo') {
    // Only allow digits and max 10 characters
    const digitsOnly = value.replace(/\D/g, '').slice(0, 10);
    setFormData(prev => ({ ...prev, [name]: digitsOnly }));
  } else {
    setFormData(prev => ({ ...prev, [name]: value }));
  }

  // Clear field error when user starts typing
  if (formErrors[name]) {
    setFormErrors(prev => ({ ...prev, [name]: '' }));
  }
};

  const handleSave = async (e) => {
  e.preventDefault();

    const requiredFields = [
    'candidateName', 'gender', 'mobileNo',
    'email', 'dateOfBirth', 'country', 'state', 'city',
    'address', 'nationality', 'courses'
  ];

  const newErrors = {};
  requiredFields.forEach(field => {
    if (!formData[field] || (Array.isArray(formData[field]) && formData[field].length === 0)) {
      newErrors[field] = 'This field is required';
    }
  });

    if (!selectedBranchId) {
    newErrors.branch = 'No branch selected — choose one from the navbar';
  }

  // Mobile number validation - exactly 10 digits
  if (formData.mobileNo && !/^\d{10}$/.test(formData.mobileNo)) {
    newErrors.mobileNo = 'Mobile number must be exactly 10 digits';
  }

  if (formData.email && !/\S+@\S+\.\S+/.test(formData.email)) {
    newErrors.email = 'Invalid email format';
  }

  setFormErrors(newErrors);

  if (Object.keys(newErrors).length > 0) {
    setSnackbarMessage('Please fill all required fields correctly');
    setSnackbarSeverity('error');
    setOpenSnackbar(true);
    setIsSubmitting(false);
    return;
  }

  setIsSubmitting(true);
  setSubmitError(null);

const selectedBranchObj = branches.find(b => String(b.id) === String(selectedBranchId));

  const payload = {
    enquiry: selectedEnquiry?.id || null,
    registration_date: formData.registrationDate,
    candidate_name: formData.candidateName.trim(),
    gender: formData.gender,
    mobile_no: formData.mobileNo, // Combine country code with mobile number
    email: formData.email.trim(),
    dob: formData.dateOfBirth,
    country: countries.find(c => c.name === formData.country)?.id || null,
    state: allStates.find(s => s.stateName === formData.state)?.stateId || null,
    city: allCities.find(ci => ci.cityName === formData.city)?.cityId || null,
    address: formData.address.trim(),
    nationality: nationalities.find(n => n.name === formData.nationality)?.id || null,
    registration_fee: formData.registrationFee ? parseFloat(formData.registrationFee) : null,
    courses: formData.courses
      .map(name => courses.find(c =>
        (c.name || c.course_name || c.title || '') === name
      )?.id)
      .filter(id => id != null),
    send_sms: formData.sendSMS,
     branch: selectedBranchObj?.id || selectedBranchId || null,
    organization: selectedBranchObj?.organization || selectedBranchObj?.organization_id || organizationId || null,
  
  };


    try {
      const headers = {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      };

      const response = await fetch(`${API_BASE_URL}/api/student_details/registrations/`, {
        method: 'POST',
        headers,
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        let errorData;
        try {
          errorData = await response.json();
        } catch {
          errorData = { detail: 'Server error' };
        }
        throw new Error(errorData.detail || errorData.message || `HTTP ${response.status}`);
      }

      const result = await response.json();
      console.log('Registration created:', result);

      setShowSuccessModal(true);
      setSnackbarMessage('Registration saved successfully!');
      setSnackbarSeverity('success');
      setOpenSnackbar(true);

    } catch (err) {
      console.error('Save error:', err);
      setSubmitError(err.message || 'Failed to save registration. Please try again.');
      setSnackbarMessage(err.message || 'Failed to save. Check connection or fields.');
      setSnackbarSeverity('error');
      setOpenSnackbar(true);

    } finally {
      setIsSubmitting(false);
    }
  };

 const handleCancel = () => {
  setFormData({
    sendSMS: false,
    registrationDate: new Date().toISOString().split('T')[0],
    candidateName: '',
    gender: '',
    mobileNo: '',
    email: '',
    dateOfBirth: '',
    country: '',
    state: '',
    city: '',
    address: '',
    nationality: '',
    registrationFee: '',
    courses: [],
  });
  setSelectedEnquiry(null);
  setFormErrors({});
  setMobileCountryCode('+91'); // Reset country code to default
};



  // Download a blank registration form using the same branded PDF style as Admission.
  const handleDownloadBlankRegistrationForm = async () => {
    try {
      const branchId = selectedBranchId;
      const activeBranch = (branches || []).find(
        (branch) => Number(branch.id) === Number(branchId)
      );
      let branchDetails = activeBranch || {};

      if (branchId) {
        try {
          const response = await fetch(`${API_BASE_URL}/api/master/branch/${branchId}/`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('accessToken') || ''}`,
              'Content-Type': 'application/json',
            },
          });
          if (response.ok) {
            branchDetails = { ...branchDetails, ...(await response.json()) };
          }
        } catch (error) {
          console.warn('Unable to fetch branch details for blank registration form:', error);
        }
      }

      const getOrgName = (branch) => {
        const org = branch?.organization_details || branch?.organization_data || branch?.organization;
        return branch?.organization_name ||
          branch?.org_name ||
          (org && typeof org === 'object' ? org.name || org.organization_name : '') ||
          '';
      };
      const branchName = branchDetails?.branch_name || branchDetails?.name || branchDetails?.branch || '';
      const rawLogo = branchDetails?.logo_url || branchDetails?.branch_logo_url ||
        branchDetails?.logo || branchDetails?.image_url || branchDetails?.image || '';
      const logoUrl = typeof rawLogo === 'string'
        ? (/^https?:\/\//i.test(rawLogo)
            ? rawLogo
            : rawLogo
              ? `${String(API_BASE_URL || '').replace(/\/$/, '')}/${rawLogo.replace(/^\//, '')}`
              : '')
        : rawLogo?.url || rawLogo?.image_url || '';

      const loadImage = (url) => new Promise((resolve, reject) => {
        if (!url) return resolve(null);
        const image = new Image();
        image.crossOrigin = 'anonymous';
        image.onload = () => {
          try {
            const canvas = document.createElement('canvas');
            canvas.width = image.naturalWidth || image.width;
            canvas.height = image.naturalHeight || image.height;
            canvas.getContext('2d').drawImage(image, 0, 0);
            resolve(canvas.toDataURL('image/png'));
          } catch (error) { reject(error); }
        };
        image.onerror = reject;
        image.src = url;
      });

      let logoBase64 = null;
      try { logoBase64 = await loadImage(logoUrl); }
      catch (error) { console.warn('Selected branch logo could not be embedded in the PDF:', error); }

      const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const margin = 10;
      const contentWidth = pageWidth - margin * 2;
      const toRgb = (hex, fallback) => {
        if (typeof hex !== 'string') return fallback;
        const clean = hex.trim().replace(/^#/, '');
        if (!/^[0-9a-f]{6}$/i.test(clean)) return fallback;
        return [
          parseInt(clean.slice(0, 2), 16),
          parseInt(clean.slice(2, 4), 16),
          parseInt(clean.slice(4, 6), 16),
        ];
      };
      const accent = toRgb(pdfThemeColor, [31, 78, 121]);
      const ink = toRgb(pdfTextColor, [38, 48, 58]);
      const muted = [95, 107, 119];
      const border = [185, 194, 204];
      const pale = accent.map((value) => Math.round(value + (255 - value) * 0.9));
      const orgName = getOrgName(branchDetails) || 'INSTITUTION NAME';

      const drawSection = (title, y) => {
        doc.setFillColor(...pale);
        doc.roundedRect(margin, y, contentWidth, 6.5, 1, 1, 'F');
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(8.5);
        doc.setTextColor(...accent);
        doc.text(title.toUpperCase(), margin + 2.5, y + 4.4);
        return y + 9;
      };
      const drawField = (label, x, y, width, height = 10) => {
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(7.6);
        doc.setTextColor(...ink);
        doc.text(label, x, y);
        doc.setDrawColor(...border);
        doc.setLineWidth(0.25);
        doc.line(x, y + height - 1.5, x + width, y + height - 1.5);
      };
      const drawCheckbox = (label, x, y, maxWidth) => {
        doc.setDrawColor(...muted);
        doc.setLineWidth(0.25);
        doc.rect(x, y - 2.6, 2.8, 2.8);
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(7.1);
        doc.setTextColor(...ink);
        const lines = doc.splitTextToSize(String(label || 'Option'), Math.max(10, maxWidth - 5));
        doc.text(lines[0] || '', x + 4, y - 0.2);
      };

      doc.setDrawColor(...accent);
      doc.setLineWidth(0.7);
      doc.line(margin, 8, pageWidth - margin, 8);
      if (logoBase64) {
        try { doc.addImage(logoBase64, 'PNG', margin, 11, 17, 17, undefined, 'FAST'); }
        catch (error) { console.warn('Unable to place branch logo in PDF:', error); }
      }

      // Passport-size photo placeholder, matching the Admission PDF.
      const photoW = 25;
      const photoH = 29;
      const photoX = pageWidth - margin - photoW;
      const photoY = 8;
      doc.setDrawColor(...border);
      doc.setLineWidth(0.35);
      doc.rect(photoX, photoY, photoW, photoH);
      const centerX = photoX + photoW / 2;
      const centerY = photoY + photoH / 2;
      doc.setFont('helvetica', 'normal');
      doc.setTextColor(...muted);
      doc.setFontSize(6);
      doc.text('PASSPORT', centerX, centerY - 3, { align: 'center' });
      doc.text('SIZE PHOTO', centerX, centerY, { align: 'center' });
      doc.setFontSize(5.5);
      doc.text('(Paste here)', centerX, centerY + 4, { align: 'center' });

      doc.setTextColor(...ink);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(12);
      doc.text(doc.splitTextToSize(orgName, 115), pageWidth / 2, 16, { align: 'center', maxWidth: 115 });
      if (branchName) {
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(8);
        doc.setTextColor(...muted);
        doc.text(doc.splitTextToSize(branchName, 110), pageWidth / 2, 22, { align: 'center', maxWidth: 110 });
      }
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(10);
      doc.setTextColor(...accent);
      doc.text('STUDENT REGISTRATION FORM', pageWidth / 2, 31, { align: 'center' });
      doc.setDrawColor(...border);
      doc.setLineWidth(0.3);
      doc.line(margin, 37, pageWidth - margin, 37);

      let y = 41;
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(7);
      doc.setTextColor(...muted);
      doc.text('Please fill in BLOCK LETTERS and complete all applicable fields.', margin, y);
      y += 5;

      const colGap = 6;
      const colW = (contentWidth - colGap) / 2;
      y = drawSection('Registration Details', y);
      drawField('Registration Date', margin, y, colW, 9);
      drawField('Registration Fee', margin + colW + colGap, y, colW, 9);
      y += 11;

      y = drawSection('Candidate Details', y);
      drawField('Candidate Full Name *', margin, y, contentWidth, 9);
      y += 11;
      drawField('Mobile Number *', margin, y, colW, 9);
      drawField('Email Address', margin + colW + colGap, y, colW, 9);
      y += 11;
      drawField('Date of Birth', margin, y, colW, 9);
      drawField('Nationality', margin + colW + colGap, y, colW, 9);
      y += 11;
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(7.6);
      doc.setTextColor(...ink);
      doc.text('Gender', margin, y);
      drawCheckbox('Male', margin + 22, y + 0.5, 22);
      drawCheckbox('Female', margin + 49, y + 0.5, 27);
      drawCheckbox('Other', margin + 80, y + 0.5, 25);
      y += 6;
      drawField('Country', margin, y, colW, 9);
      drawField('State', margin + colW + colGap, y, colW, 9);
      y += 11;
      drawField('City', margin, y, colW, 9);
      drawField('Full Address', margin + colW + colGap, y, colW, 9);
      y += 13;

      y = drawSection('Course Details', y);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(7.5);
      doc.setTextColor(...ink);
      doc.text('Course / Programme — Tick applicable option(s):', margin, y);
      y += 4;
      const availableCourses = Array.isArray(courses) ? courses : [];
      if (availableCourses.length) {
        const optionW = contentWidth / 2;
        const courseRows = Math.ceil(availableCourses.length / 2);
        const courseRowH = availableCourses.length > 8 ? 4.3 : 5;
        availableCourses.forEach((course, index) => {
          const label = course?.course_name || course?.name || course?.title || `Course ${course?.id || ''}`;
          drawCheckbox(label, margin + (index % 2) * optionW, y + Math.floor(index / 2) * courseRowH, optionW);
        });
        y += courseRows * courseRowH + 3;
      } else {
        drawField('Course / Programme', margin, y, contentWidth, 8);
        y += 9;
      }

      y = drawSection('Declaration & Office Use', y);
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(7.1);
      doc.setTextColor(...ink);
      const declaration = 'I declare that the information provided above is true and complete to the best of my knowledge.';
      const declarationLines = doc.splitTextToSize(declaration, contentWidth);
      doc.text(declarationLines, margin, y);
      y += declarationLines.length * 3.5 + 3;
      drawField('Candidate Signature', margin, y, colW, 8);
      drawField('Date', margin + colW + colGap, y, colW, 8);
      y += 10;
      drawField('Registration No. (Office Use)', margin, y, colW, 8);
      drawField('Verified By (Office Use)', margin + colW + colGap, y, colW, 8);

      const noteY = pageHeight - 7;
      doc.setDrawColor(...border);
      doc.line(margin, noteY - 5, pageWidth - margin, noteY - 5);
      doc.setFont('helvetica', 'italic');
      doc.setFontSize(6.7);
      doc.setTextColor(...muted);
      doc.text('Please attach copies of the required supporting documents, if requested.', pageWidth / 2, noteY, { align: 'center', maxWidth: contentWidth });

      if (y > noteY - 8) {
        console.warn('Course catalogue is long; review the one-page print layout for this branch.');
      }
      doc.save('blank-student-registration-form.pdf');
      setSnackbarMessage('Blank registration form downloaded successfully.');
      setSnackbarSeverity('success');
      setOpenSnackbar(true);
    } catch (error) {
      console.error('Failed to generate blank registration form:', error);
      setSnackbarMessage('Could not generate the blank registration form. Please try again.');
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    }
  };

  const filteredEnquiries = enquiries.filter((enq) => {
    if (!enquirySearchTerm) return true;
    const term = enquirySearchTerm.toLowerCase();
    return (
      (enq.student_name || '').toLowerCase().includes(term) ||
      (enq.enquiry_code || '').toLowerCase().includes(term) ||
      (enq.contact_no || enq.mobile_no || '').includes(term) ||
      (enq.parent_name || '').toLowerCase().includes(term)
    );
  });

  return (
    <Container maxWidth="lg" sx={{ my: 0 }}>
      <Box
        elevation={3}
        sx={{
          p: 4,
          borderRadius: 2,
          backgroundColor: theme.palette.background.paper,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 2,
            flexWrap: 'wrap',
            mb: 3,
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: 'bold', color: theme.palette.primary.main }}>
            New Registration
          </Typography>
          <Button
            variant="contained"
            onClick={handleDownloadBlankRegistrationForm}
            startIcon={<FileDownloadIcon />}
            sx={{
              minHeight: 42,
              borderRadius: 2,
              px: 2.5,
              fontWeight: 700,
              textTransform: 'none',
            }}
          >
            Download Blank Form (PDF)
          </Button>
        </Box>

        {showSuccessModal ? (
          <Modal
            open={showSuccessModal}
            onClose={() => setShowSuccessModal(false)}
            BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
          >
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 400,
                bgcolor: theme.palette.background.paper,
                borderRadius: 2,
                boxShadow: 24,
                overflow: 'hidden',
              }}
            >
              <Box sx={{ backgroundColor: theme.palette.primary.main, padding: '12px 16px' }}>
                <Typography variant="h6" sx={{ color: theme.palette.primary.contrastText }}>
                  Registration Added ✅
                </Typography>
              </Box>
              <Box sx={{ padding: '20px' }}>
                <Typography sx={{ mb: 2 }}>
                  Registration Added Successfully
                </Typography>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      setShowSuccessModal(false);
                      navigate(-1);
                    }}
                  >
                    OK
                  </Button>
                </Box>
              </Box>
            </Box>
          </Modal>
        ) : (
          <form onSubmit={handleSave}>
            <FormControlLabel
              control={
                <Checkbox
                  name="sendSMS"
                  checked={formData.sendSMS}
                  onChange={handleChange}
                  sx={{
                    color: theme.palette.text.primary,
                    '&.Mui-checked': {
                      color: theme.palette.text.primary,
                    },
                  }}
                />
              }
              label="Send SMS"
              sx={{ mb: 3 }}
            />
          
            <TextField
              label="Select Enquiry (Optional)"
              variant="outlined"
              fullWidth
              value={
                selectedEnquiry
                  ? `${selectedEnquiry.enquiry_code || 'ENQ-' + selectedEnquiry.id} - ${selectedEnquiry.student_name || selectedEnquiry.candidate_name || 'Unknown'}`
                  : ''
              }
              InputLabelProps={{
                style: {
                  color: theme.palette.text.primary,
                  fontWeight: 400,
                },
              }}
              placeholder="Click search icon to choose enquiry"
              onClick={() => setEnquiryModalOpen(true)}
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setEnquiryModalOpen(true)}
                      edge="end"
                      sx={{ color: theme.palette.primary.main }}
                    >
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{ mb: 3 }}
            />
            <TextField
              label="Registration Date"
              type="date"
              variant="outlined"
              fullWidth
              name="registrationDate"
              value={formData.registrationDate}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
              sx={{
                mb: 3,
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.text.primary,
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.primary.main,
                },
                '& .MuiInputBase-input[type="date"]::-webkit-calendar-picker-indicator': {
                  filter: theme.palette.mode === 'dark' ? 'invert(1)' : 'none',
                },
              }}
              required
            />
            <TextField
              label="Candidate Name"
              variant="outlined"
              fullWidth
              name="candidateName"
              value={formData.candidateName}
              onChange={handleChange}
              error={!!formErrors.candidateName}
              helperText={formErrors.candidateName}
              sx={{
                mb: 3,
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.text.primary,
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.primary.main,
                },
              }}
              required
            />
            <FormControl fullWidth sx={{ mb: 3 }} required error={!!formErrors.gender}>
              <InputLabel sx={{ color: theme.palette.text.primary, '&.Mui-focused': { color: theme.palette.primary.main } }}>
                Gender
              </InputLabel>
              <Select
                name="gender"
                value={formData.gender}
                label="Gender"
                onChange={handleChange}
                sx={{
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                {staticGenderData.map((gender) => (
                  <MenuItem key={gender.id} value={gender.name}>
                    {gender.name}
                  </MenuItem>
                ))}
              </Select>
              {formErrors.gender && <FormHelperText>{formErrors.gender}</FormHelperText>}
            </FormControl>
            <TextField
  label="Mobile No."
  type="tel"
  inputProps={{ maxLength: 10, inputMode: 'numeric' }}
  variant="outlined"
  fullWidth
  name="mobileNo"
  value={formData.mobileNo}
  onChange={handleChange}
  error={!!formErrors.mobileNo}
    FormHelperTextProps={{
    style: {
      color: theme.palette.mode === 'dark' 
        ? '#e0e0e0'           // light gray-white → very readable on dark bg
        : '#484848',          // near-black → sharp on light bg
      fontWeight: 500,        // slightly bolder
      opacity: 1,
    },
  }}
  helperText={formErrors.mobileNo || "Enter 10-digit mobile number"}
  InputProps={{
    startAdornment: (
      <InputAdornment position="start">
        <Select
          value={mobileCountryCode}
          onChange={(e) => setMobileCountryCode(e.target.value)}
          variant="standard"
          disableUnderline
          sx={{
            minWidth: 70,
            '& .MuiSelect-select': {
              py: 0.5,
              px: 1,
              fontSize: '0.875rem',
              color: theme.palette.text.primary,
            },
          }}
          MenuProps={{
            PaperProps: {
              sx: { maxHeight: 300 },
            },
          }}
        >
          <MenuItem value="+91">🇮🇳 +91 (India)</MenuItem>
          <MenuItem value="+1">🇺🇸 +1 (USA)</MenuItem>
          <MenuItem value="+44">🇬🇧 +44 (UK)</MenuItem>
          <MenuItem value="+61">🇦🇺 +61 (Australia)</MenuItem>
          <MenuItem value="+971">🇦🇪 +971 (UAE)</MenuItem>
          <MenuItem value="+65">🇸🇬 +65 (Singapore)</MenuItem>
          <MenuItem value="+60">🇲🇾 +60 (Malaysia)</MenuItem>
          <MenuItem value="+966">🇸🇦 +966 (Saudi Arabia)</MenuItem>
          <MenuItem value="+974">🇶🇦 +974 (Qatar)</MenuItem>
          <MenuItem value="+968">🇴🇲 +968 (Oman)</MenuItem>
          <MenuItem value="+973">🇧🇭 +973 (Bahrain)</MenuItem>
          <MenuItem value="+965">🇰🇼 +965 (Kuwait)</MenuItem>
          <MenuItem value="+64">🇳🇿 +64 (New Zealand)</MenuItem>
          <MenuItem value="+49">🇩🇪 +49 (Germany)</MenuItem>
          <MenuItem value="+33">🇫🇷 +33 (France)</MenuItem>
          <MenuItem value="+81">🇯🇵 +81 (Japan)</MenuItem>
          <MenuItem value="+86">🇨🇳 +86 (China)</MenuItem>
          <MenuItem value="+92">🇵🇰 +92 (Pakistan)</MenuItem>
          <MenuItem value="+880">🇧🇩 +880 (Bangladesh)</MenuItem>
          <MenuItem value="+94">🇱🇰 +94 (Sri Lanka)</MenuItem>
          <MenuItem value="+977">🇳🇵 +977 (Nepal)</MenuItem>
          <MenuItem value="+27">🇿🇦 +27 (South Africa)</MenuItem>
          <MenuItem value="+234">🇳🇬 +234 (Nigeria)</MenuItem>
          <MenuItem value="+254">🇰🇪 +254 (Kenya)</MenuItem>
        </Select>
        <Box
          sx={{
            width: '1px',
            height: '24px',
            backgroundColor: theme.palette.divider,
            mx: 0.5,
          }}
        />
      </InputAdornment>
    ),
  }}
  sx={{
    mb: 3,
    '& .MuiInputLabel-root': {
      color: theme.palette.text.primary,
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: theme.palette.primary.main,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.text.primary,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
  }}
  required
/>
            <TextField
              label="Email"
              type="email"
              variant="outlined"
              fullWidth
              name="email"
              value={formData.email}
              onChange={handleChange}
              error={!!formErrors.email}
              helperText={formErrors.email}
              sx={{
                mb: 3,
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.text.primary,
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.primary.main,
                },
              }}
              required
            />
            <TextField
              label="Date of Birth"
              type="date"
              variant="outlined"
              fullWidth
              name="dateOfBirth"
              value={formData.dateOfBirth}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
              error={!!formErrors.dateOfBirth}
              helperText={formErrors.dateOfBirth}
              sx={{
                mb: 3,
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.text.primary,
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.primary.main,
                },
                '& .MuiInputBase-input[type="date"]::-webkit-calendar-picker-indicator': {
                  filter: theme.palette.mode === 'dark' ? 'invert(1)' : 'none',
                },
              }}
              required
            />
           
            <FormControl fullWidth sx={{ mb: 3 }} required error={!!formErrors.country}>
              <InputLabel sx={{ color: theme.palette.text.primary, '&.Mui-focused': { color: theme.palette.primary.main } }}>
                Country
              </InputLabel>
              <Select
                name="country"
                value={formData.country}
                label="Country"
                onChange={handleChange}
                sx={{
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                {countries.map((country, index) => (
                  <MenuItem
                    key={country.id || index}
                    value={country.name || country.country_name || country}
                  >
                    {country.name || country.country_name || country}
                  </MenuItem>
                ))}
              </Select>
              {formErrors.country && <FormHelperText>{formErrors.country}</FormHelperText>}
            </FormControl>
            <FormControl fullWidth sx={{ mb: 3 }} required error={!!formErrors.state}>
              <InputLabel sx={{ color: theme.palette.text.primary, '&.Mui-focused': { color: theme.palette.primary.main } }}>
                State
              </InputLabel>
              <Select
                name="state"
                value={formData.state}
                label="State"
                onChange={handleChange}
                disabled={!formData.country}
                sx={{
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                {filteredStates.map((state) => (
                  <MenuItem key={state.stateId} value={state.stateName}>
                    {state.stateName}
                  </MenuItem>
                ))}
              </Select>
              {formErrors.state && <FormHelperText>{formErrors.state}</FormHelperText>}
            </FormControl>
            <FormControl fullWidth sx={{ mb: 3 }} required error={!!formErrors.city}>
              <InputLabel sx={{ color: theme.palette.text.primary, '&.Mui-focused': { color: theme.palette.primary.main } }}>
                City
              </InputLabel>
              <Select
                name="city"
                value={formData.city}
                label="City"
                onChange={handleChange}
                disabled={!formData.state}
                sx={{
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                {filteredCities.map((city) => (
                  <MenuItem key={city.cityId} value={city.cityName}>
                    {city.cityName}
                  </MenuItem>
                ))}
              </Select>
              {formErrors.city && <FormHelperText>{formErrors.city}</FormHelperText>}
            </FormControl>
            <TextField
              label="Address"
              variant="outlined"
              fullWidth
              name="address"
              value={formData.address}
              onChange={handleChange}
              error={!!formErrors.address}
              helperText={formErrors.address}
              sx={{
                mb: 3,
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.text.primary,
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.primary.main,
                },
              }}
              required
            />
            <FormControl fullWidth sx={{ mb: 3 }} required error={!!formErrors.nationality}>
              <InputLabel sx={{ color: theme.palette.text.primary, '&.Mui-focused': { color: theme.palette.primary.main } }}>
                Nationality
              </InputLabel>
              <Select
                name="nationality"
                value={formData.nationality}
                label="Nationality"
                onChange={handleChange}
                sx={{
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                {nationalities.map((nat, index) => (
                  <MenuItem
                    key={nat.id || nat.code || index}
                    value={nat.name || nat.nationality || nat.nationality_name || nat}
                  >
                    {nat.name || nat.nationality || nat.nationality_name || nat}
                  </MenuItem>
                ))}
              </Select>
              {formErrors.nationality && <FormHelperText>{formErrors.nationality}</FormHelperText>}
            </FormControl>
            <TextField
            required
            type='number'
              label="Registration Fee"
              variant="outlined"
              fullWidth
              name="registrationFee"
              value={formData.registrationFee}
              onChange={handleChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <span style={{ color: theme.palette.text.primary }}>₹</span>
                  </InputAdornment>
                ),
              }}
              sx={{
                mb: 3,
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.text.primary,
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.primary.main,
                },
              }}
            />
<TextField
  label="Course(s) *"
  variant="outlined"
  fullWidth
  value={tempCourses.join(', ')}
  placeholder="Click to select courses"
  onClick={() => {
    setTempCourses([...formData.courses]);
    setCourseModalOpen(true);
  }}
  InputProps={{
    readOnly: true,
    endAdornment: (
      <InputAdornment position="end">
        <IconButton
          onClick={() => {
            setTempCourses([...formData.courses]);
            setCourseModalOpen(true);
          }}
          edge="end"
        >
          <SearchIcon />
        </IconButton>
      </InputAdornment>
    ),
  }}
  error={!!formErrors.courses}
   FormHelperTextProps={{
    style: {
      color: theme.palette.mode === 'dark' 
        ? '#e0e0e0'           // light gray-white → very readable on dark bg
        : '#484848',          // near-black → sharp on light bg
      fontWeight: 500,        // slightly bolder
      opacity: 1,
    },
  }}
  helperText={formErrors.courses || "Click to select courses"}
  sx={{
    mb: 3,
    '& .MuiInputLabel-root': {
      color: theme.palette.text.primary,
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: theme.palette.primary.main,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.text.primary,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
    cursor: 'pointer',
  }}
/>

{/* Course Selection Modal */}
<Modal
  open={courseModalOpen}
  onClose={() => setCourseModalOpen(false)}
  aria-labelledby="course-modal-title"
  BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
>
  <Box
    sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: { xs: '90%', md: 500 },
      maxHeight: '80vh',
      bgcolor: theme.palette.background.paper,
      borderRadius: 2,
      boxShadow: 24,
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    {/* Header */}
    <Box sx={{ p: 2, bgcolor: theme.palette.primary.main }}>
      <Typography variant="h6" sx={{ color: theme.palette.primary.contrastText, fontWeight: 'bold' }}>
        Select Courses
      </Typography>
    </Box>

    {/* Scrollable Course List */}
    <CustomTableScrollbar sx={{ flex: 1, overflowY: 'auto', p: 2 }}>
      {courses.map((course, index) => {
        const courseName = course.name || course.course_name || course.title || course;
        const isChecked = tempCourses.indexOf(courseName) > -1;
        return (
          <FormControlLabel
            key={course.id || index}
            control={
              <Checkbox
                checked={isChecked}
                onChange={(e) => {
                  if (e.target.checked) {
                    setTempCourses([...tempCourses, courseName]);
                  } else {
                    setTempCourses(tempCourses.filter(c => c !== courseName));
                  }
                }}
                sx={{
                  color: theme.palette.primary.main,
                  '&.Mui-checked': { color: theme.palette.primary.main },
                }}
              />
            }
            label={courseName}
            sx={{
              display: 'flex',
              width: '100%',
              mb: 1,
              '& .MuiTypography-root': {
                color: theme.palette.text.primary,
              },
            }}
          />
        );
      })}
    </CustomTableScrollbar>

    {/* Footer with OK Button */}
    <Box sx={{ 
      p: 2, 
      display: 'flex', 
      justifyContent: 'flex-end', 
      borderTop: `1px solid ${theme.palette.divider}`,
      gap: 2
    }}>
      <Button 
        variant="outlined" 
        onClick={() => setCourseModalOpen(false)}
        sx={{ textTransform: 'none' }}
       data-app-cancel="true">
        Cancel
      </Button>
      <Button 
        variant="contained" 
        onClick={() => {
          setFormData(prev => ({ ...prev, courses: tempCourses }));
          setCourseModalOpen(false);
        }}
        sx={{ textTransform: 'none' }}
      >
        OK
      </Button>
    </Box>
  </Box>
</Modal>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
              <Tooltip
                title={
                    !formData.candidateName ? 'Enter Candidate Name' :
                      !formData.gender ? 'Select Gender' :
                        !formData.mobileNo ? 'Enter Mobile No.' :
                          !formData.email ? 'Enter Email' :
                            !formData.dateOfBirth ? 'Enter Date of Birth' :
                             !selectedBranchId ? 'Select a branch from the navbar' :
                                !formData.country ? 'Select Country' :
                                  !formData.state ? 'Select State' :
                                    !formData.city ? 'Select City' :
                                      !formData.address ? 'Enter Address' :
                                        !formData.nationality ? 'Select Nationality' :
                                          !formData.courses.length ? 'Select Course' : ''
                }
                arrow
              >
                <span>
                  <Button
                    variant="contained"
                    type="submit"
                    disabled={
                      !formData.candidateName ||
                      !formData.gender ||
                      !formData.mobileNo ||
                      !formData.email ||
                      !formData.dateOfBirth ||
                      !selectedBranchId ||
                      !formData.country ||
                      !formData.state ||
                      !formData.city ||
                      !formData.address ||
                      !formData.nationality ||
                      !formData.courses.length ||
                      !formData.registrationFee ||
                      isSubmitting
                    }
                  >
                    {isSubmitting ? 'SAVING...' : 'SAVE'}
                  </Button>
                </span>
              </Tooltip>
              <Button
                variant="outlined"
                color="error"
                onClick={handleCancel}
                disabled={isSubmitting}
              >
                RESET
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => navigate(-1)}
                disabled={isSubmitting}
              >
                BACK
              </Button>
            </Box>
          </form>
        )}
      </Box>
      <Modal
        open={enquiryModalOpen}
        onClose={() => setEnquiryModalOpen(false)}
        aria-labelledby="enquiry-modal-title"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '90%', md: 900 },
            maxHeight: '85vh',
            bgcolor: theme.palette.background.paper,
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {/* Header */}
          <Box sx={{ p: 3, bgcolor: theme.palette.primary.main, color: 'white' }}>
            <Typography id="enquiry-modal-title" variant="h6">
              Select Enquiry
            </Typography>
          </Box>

          {/* Optional search inside modal */}
          <Box sx={{ p: 2, borderBottom: `1px solid ${theme.palette.divider}` }}>
            <TextField
              fullWidth
              size="small"
              placeholder="Search by name, code, mobile..."
              value={enquirySearchTerm}
              onChange={(e) => setEnquirySearchTerm(e.target.value)}
              variant="outlined"
            />
          </Box>

          {/* Scrollable table area */}
          <CustomTableScrollbar sx={{ flex: 1, overflowY: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ backgroundColor: theme.palette.action.hover }}>
                  <th style={{ padding: '12px', textAlign: 'left' }}>Enquiry ID</th>
                  <th style={{ padding: '12px', textAlign: 'left' }}>Student Name</th>
                  <th style={{ padding: '12px', textAlign: 'left' }}>Enquiry Code</th>
                  <th style={{ padding: '12px', textAlign: 'left' }}>Parent/Guardian</th>
                  <th style={{ padding: '12px', textAlign: 'left' }}>Contact No.</th>
                  <th style={{ padding: '12px', textAlign: 'left' }}>Enquiry Date</th>
                  <th style={{ padding: '12px', textAlign: 'left' }}>Class</th>
                  <th style={{ padding: '12px', textAlign: 'center' }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredEnquiries.map((enq) => (
                  <tr
                    key={enq.id}
                    style={{ borderBottom: `1px solid ${theme.palette.divider}` }}
                  >
                    <td style={{ padding: '12px' }}>{enq.id}</td>
                    <td style={{ padding: '12px' }}>{enq.student_name || enq.candidate_name || '-'}</td>
                    <td style={{ padding: '12px' }}>{enq.enquiry_code || '-'}</td>
                    <td style={{ padding: '12px' }}>{enq.parent_name || enq.guardian || '-'}</td>
                    <td style={{ padding: '12px' }}>{enq.contact_no || enq.mobile_no || '-'}</td>
                    <td style={{ padding: '12px' }}>{enq.enquiry_date || '-'}</td>
                    <td style={{ padding: '12px' }}>{enq.class_name || enq.course || '-'}</td>
                    <td style={{ padding: '12px', textAlign: 'center' }}>
                     <Button
  variant="contained"
  size="small"
  color="primary"
  onClick={() => {
    setSelectedEnquiry(enq);

    let selectedCourseIds = [];

    if (Array.isArray(enq.courses)) {
      selectedCourseIds = enq.courses.map(id => Number(id)).filter(id => !isNaN(id));
    } else if (enq.course_ids) {
      selectedCourseIds = Array.isArray(enq.course_ids)
        ? enq.course_ids.map(id => Number(id)).filter(id => !isNaN(id))
        : [];
    } else {
      const singleId = enq.course_id || enq.course || enq.class_id || enq.class || null;
      if (singleId) {
        selectedCourseIds = [Number(singleId)].filter(id => !isNaN(id));
      }
    }

    const prefilledCourseNames = selectedCourseIds
      .map(id => {
        const course = courses.find(c => c.id === id);
        return course?.name || course?.course_name || course?.title || course?.code || '';
      })
      .filter(name => name.trim() !== '');

    const nationalityId =
      enq.nationality_id ||
      enq.nationality ||
      enq.nationality_code ||
      null;

    const nationalityObj = nationalities.find(n => n.id === nationalityId);
    const prefilledNationality =
      nationalityObj?.name ||
      nationalityObj?.nationality ||
      nationalityObj?.nationality_name ||
      nationalityObj?.title ||
      '';

    const prefilledName =
      enq.student_name ||
      enq.candidate_name ||
      enq.name ||
      enq.full_name ||
      '';

    const prefilledMobile =
      enq.contact_no ||
      enq.mobile_no ||
      enq.mobile ||
      enq.phone ||
      enq.contact ||
      '';

    // Extract only the digits from the mobile number (remove country code if present)
    let extractedMobile = prefilledMobile;
    let extractedCountryCode = '+91';
    
    if (prefilledMobile) {
      // Check for common country codes
      const countryCodes = ['+91', '+1', '+44', '+61', '+971', '+65', '+60', '+966', '+974', '+968', '+973', '+965', '+64', '+49', '+33', '+81', '+86', '+92', '+880', '+94', '+977', '+27', '+234', '+254'];
      for (const code of countryCodes) {
        if (prefilledMobile.startsWith(code)) {
          extractedCountryCode = code;
          extractedMobile = prefilledMobile.slice(code.length).replace(/\D/g, '');
          break;
        }
      }
      // If no country code found, take last 10 digits
      if (extractedMobile === prefilledMobile) {
        const digits = prefilledMobile.replace(/\D/g, '');
        if (digits.length > 10) {
          extractedMobile = digits.slice(-10);
        } else {
          extractedMobile = digits;
        }
      }
    }
    
    setMobileCountryCode(extractedCountryCode);

    const prefilledEmail =
      enq.email ||
      enq.student_email ||
      enq.guardian_email ||
      enq.email_address ||
      '';

    setFormErrors({});

    setFormData(prev => ({
      ...prev,
      candidateName: prefilledName || prev.candidateName,
      mobileNo: extractedMobile || prev.mobileNo,
      email: prefilledEmail || prev.email,
      courses: prefilledCourseNames.length > 0
        ? prefilledCourseNames
        : prev.courses,
      nationality: prefilledNationality || prev.nationality,
    }));

    setEnquiryModalOpen(false);
  }}
>
  SELECT
</Button>
                    </td>
                  </tr>
                ))}
                {filteredEnquiries.length === 0 && (
                  <tr>
                    <td colSpan={8} style={{ padding: '20px', textAlign: 'center', color: theme.palette.text.secondary }}>
                      No matching enquiries found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </CustomTableScrollbar>

          {/* Footer */}
          <Box sx={{ p: 2, display: 'flex', justifyContent: 'flex-end', borderTop: `1px solid ${theme.palette.divider}` }}>
            <Button variant="outlined" onClick={() => setEnquiryModalOpen(false)}>
              Close
            </Button>
          </Box>
        </Box>
      </Modal>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default AddRegistration;